import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import { LuFileEdit as Edit, LuAlertCircle as AlertCircle } from "react-icons/lu";

type TextAreaProps = {
  id?: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  error?: string;
  registration?: UseFormRegisterReturn;
  onChange?: (value: string) => void;
  previewMode?: boolean;
  value?: string;
  maxLength?: number;
};

export const TextArea: React.FC<TextAreaProps> = ({
  id,
  label,
  placeholder,
  disabled = false,
  required = false,
  className,
  error,
  registration,
  onChange,
  previewMode = false,
  value = "",
  maxLength = 5000,
}) => {
  const { name, ref, onBlur, onChange: rhfOnChange } = registration ?? {};

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    rhfOnChange?.(e);
    onChange?.(e.target.value);
  };

  const currentLength = value?.length ?? 0;

  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="block text-sm font-semibold text-gray-700 mb-1">
          {label}
        </label>
      )}

      {!previewMode ? (
        <div className="space-y-2">
          <textarea
            id={id}
            name={name}
            placeholder={placeholder}
            disabled={disabled}
            required={required}
            maxLength={maxLength}
            onBlur={onBlur}
            onChange={handleChange}
            ref={ref}
            value={value}
            className={`w-full h-40 px-4 py-3 border rounded-lg resize-none transition-all duration-200 placeholder-gray-500
    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
    ${error ? "border-red-300" : "border-gray-300"}`}
          />
          {error && (
            <div className="flex items-center space-x-2 text-red-600 text-sm">
              <AlertCircle size={16} />
              <span>{error}</span>
            </div>
          )}
        </div>
      ) : (
        <div className="w-full h-40 px-4 py-3 border border-gray-200 rounded-lg bg-gray-50 overflow-y-auto">
          <div className="whitespace-pre-wrap text-gray-800">
            {value || <span className="text-gray-500 italic">Your post preview will appear here...</span>}
          </div>
        </div>
      )}

      <div className="flex justify-between text-sm text-gray-500">
        <span className={currentLength > maxLength ? "text-red-500 font-medium" : ""}>
          {currentLength}/{maxLength} characters
        </span>
        <span className="flex items-center space-x-1">
          <Edit size={14} />
          <span>Rich text formatting</span>
        </span>
      </div>
    </div>
  );
};
